import React, { useLayoutEffect, useRef } from "react";
import "./Section3.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const titleLine1 = "RUN FREE";
const titleLine2 = "GROW STRONG";
const paragraphText =
  "The Dandelion Run Community is a youth-oriented, noncompetitive approach to running that cultivates confidence, resilience, and a lifelong love of movement. Rooted in the principles of connection and community, our program creates a welcoming space for all skill levels to engage in running activities, games, land-based learning, and wellness.";

function Section3() {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const paragraphRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      ScrollTrigger.matchMedia({
        // --- Desktop: Pin & crossfade ---
        "(min-width: 1024px)": function () {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: sectionRef.current,
              pin: true,
              start: "top top",
              end: "+=1500",
              scrub: 1,
            },
          });

          gsap.set(titleRef.current, { opacity: 1, scale: 1 });
          gsap.set(paragraphRef.current, { opacity: 0, scale: 0.8 });

          tl.to(titleRef.current, {
            opacity: 0,
            scale: 0.8,
            duration: 1,
            ease: "power2.inOut",
          });

          tl.to(
            paragraphRef.current,
            { opacity: 1, scale: 1, duration: 1, ease: "power2.inOut" },
            "<"
          );
        },

        // --- Tablet & Mobile: Waterfall reveal ---
        "(max-width: 1023px)": function () {
          gsap.fromTo(
            [titleRef.current, paragraphRef.current],
            { opacity: 0, y: 50 },
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.4, // title first, then paragraph
              ease: "power2.out",
              scrollTrigger: {
                trigger: sectionRef.current,
                start: "top 80%",
                toggleActions: "play none none none",
                once: true,
              },
            }
          );
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="section-3" ref={sectionRef}>
      <div className="section-3-content">
        {/* Title */}
        <div className="section-3-title" ref={titleRef}>
          <h1>{titleLine1}</h1>
          <h2>{titleLine2}</h2>
        </div>

        {/* Paragraph */}
        <div className="section-3-paragraph" ref={paragraphRef}>
          <p>{paragraphText}</p>
        </div>
      </div>

      {/* Mountains */}
      <div className="section-3-mountains"></div>
    </section>
  );
}

export default Section3;
